// src/components/LanguageToggle.jsx
import { useLang } from '../lib/i18n.jsx';

export default function LanguageToggle() {
  const { lang, setLanguage } = useLang();
  return (
    <div className="inline-flex rounded-full border border-ink/15 bg-white p-0.5 text-xs">
      {['en', 'sw'].map((l) => (
        <button
          key={l}
          onClick={() => setLanguage(l)}
          className={`px-2.5 py-1 rounded-full font-medium transition-colors ${
            lang === l ? 'bg-sage text-white' : 'text-ink/60 hover:text-ink'
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
